module.exports = __webpack_public_path__ + "img/cake-12.60046d1f.svg";